//
import SubFamilyModel from '@/models/Warehouse/WhSubfamily'

/**
 *
 */
const fetchAll = async () => {
    //
    try {
        //
        const response = await SubFamilyModel.params({ get_all_results: true }).get()
        //
        return response.data
    } catch (error) {
        //
        return error.response.data
    }
}

//
export default fetchAll
